import "core-js/modules/es.object.to-string.js";
import { updateEmailSetting } from '@/services/systemsetting';
export default {
  name: 'emailSetting',
  i18n: require('./../i18n-basucSettings'),
  props: ['systemSetting'],
  watch: {
    systemSetting: function systemSetting() {
      var self = this;
      self.systemSettingData = self.systemSetting;
      self.initData();
    }
  },
  data: function data() {
    return {
      loadingSave: false,
      systemSettingData: this.systemSetting,
      dataForm: {
        id: "",
        lastUpdateTime: "",
        SMTPHost: '',
        SMTPAccount: '',
        SMTPPassword: '',
        SMTPPort: '',
        SMTPTimeout: '',
        adminEmail: '',
        abnormalMessageStatus: 0
      },
      rules: {
        SMTPHost: [{
          required: true,
          message: this.$t('basicSettings.enterPleaseSMTPHost'),
          trigger: 'blur'
        }],
        SMTPAccount: [{
          required: true,
          message: this.$t('basicSettings.enterPleaseSMTPAccount'),
          trigger: 'blur'
        }],
        SMTPPassword: [{
          required: true,
          message: this.$t('basicSettings.enterPleaseSMTPPassword'),
          trigger: 'blur'
        }],
        SMTPPort: [{
          required: true,
          message: this.$t('basicSettings.enterPleaseSMTPPort'),
          trigger: 'blur'
        }],
        SMTPTimeout: [{
          required: true,
          message: this.$t('basicSettings.enterPleaseSMTPTimeout'),
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var self = this;
    self.initData();
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('onClick', e, tinymce);
    },
    initData: function initData() {
      var self = this;
      self.dataForm = {
        SMTPHost: self.systemSettingData.sMTPHost,
        SMTPAccount: self.systemSettingData.sMTPAccount,
        SMTPPassword: self.systemSettingData.sMTPPassword,
        SMTPPort: self.systemSettingData.sMTPPort,
        SMTPTimeout: self.systemSettingData.sMTPTimeout,
        adminEmail: self.systemSettingData.adminEmail,
        id: self.systemSettingData.id,
        lastUpdateTime: self.systemSettingData.lastUpdateTime,
        abnormalMessageStatus: self.systemSettingData.abnormalMessageStatus
      };
    },
    /* 保存 */save: function save() {
      var _this = this;
      var self = this;
      self.loadingSave = true;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          updateEmailSetting(self.dataForm).then(function (result) {
            if (result.data.code == 200) {
              //更新成功后更新 最后更新时间
              self.$emit('update');
              self.loadingSave = false;
              _this.$message.success(_this.$t('public.saveSuccessfully'));
            } else {
              self.loadingSave = false;
              _this.$message.error(result.data.message);
              return false;
            }
          }).finally(function () {
            _this.loadingSave = false;
          });
        } else {
          self.loadingSave = false;
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};